import { ArrowBackIosNew, ArrowForwardIos, Check } from '@mui/icons-material';
import { Box, Card, CardContent, Divider, Link, List, ListItem, ListItemIcon, Typography } from '@mui/material'
import React, { useRef } from 'react'
import Slider from 'react-slick'

const BenefitSlider = ({ benefitList }) => {
    const sliderRef = useRef(null);
    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 400,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        responsive: [
          {
            breakpoint: 1400,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
        customPaging: (i) => (
          <Box
            sx={{
              width: 19,
              height: 19,
              borderRadius: "50%",
              backgroundColor: "#d3d3d3",
              display: "inline-block",
            }}
          />
        ),
        appendDots: (dots) => (
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", bottom:'-65px'}}>
            <button
              onClick={() => sliderRef.current.slickPrev()}
              style={{
                marginRight: "30px",
                cursor: "pointer",
                background: "none",
                border: "none",
                fontSize: "24px",
                fontWeight: 600,
                color: "#F59C1E",
              }}
            >
            <ArrowBackIosNew />
            </button>
            <Box 
                sx={{
                display: {xs: 'none', md: "flex"},
                padding: 0,
                margin: "0px !important",
                "& .slick-active div": {
                  backgroundColor: "#F59C1E !important",
                },
              }}
            >{dots}</Box>
            <button
              onClick={() => sliderRef.current.slickNext()}
              style={{
                marginLeft: "30px",
                cursor: "pointer",
                background: "none",
                border: "none",
                fontSize: "24px",
                fontWeight: 600,
                color: "#F59C1E",
              }}
            >
            <ArrowForwardIos />
            </button>
          </Box>
        ),
    };
    return (
        <Slider ref={sliderRef} {...sliderSettings}>
            {benefitList.map((item, index) => (
                <Box key={index} sx={{ padding: 3 }}>
                  <Card sx={{
                      boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.4)',
                      borderRadius: '10px',
                    }}>
                      <Box sx={{ p:2 }}> 
                        <img src={item?.src} style={{ height: 'auto' }} alt={item?.title} />
                      </Box>
                      <CardContent sx={{ minHeight: '190px'}}>
                        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>{item.title}</Typography>
                        <Typography variant="body2" color="#818181" sx={{ mb: 2 }}>
                            {item?.description}
                        </Typography>
                        <Divider sx={{ mb: 2 }} />
                        <Box sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}>
                          <List sx={{ pr: 0, py: 0 }}>
                              {item?.coverage_list.map((coverage, idx) => (
                                <ListItem key={idx} sx={{ p: 0 }}>
                                    <Check sx={{ mr:2 , color:'#818181' }}  />
                                    <Typography sx={{ fontSize: '13px', fontWeight: 600, color:'#818181' }} >{coverage}</Typography>
                                </ListItem>
                              ))}
                          </List>
                          <Box sx={{ ml: 2 }}>
                            <Link to='/' sx={{ fontSize: '13px', fontWeight: 600, color:"red" }}>T&C</Link>
                          </Box>
                        </Box>
                      </CardContent>
                  </Card>
                </Box>
            ))}
        </Slider>
    )
}

export default BenefitSlider